<!-- Component for displaying the Everplans item modal -->
<template>
	<PrecoaModal
		:open="modelValue"
		@update:open="(value) => emit('update:modelValue', value ?? false)"
	>
		<div class="text-center">
			<h2 class="text-secondary-900 mt-6 text-2xl font-semibold">
				{{ t('essentialsSlide.everplansModal.title') }}
			</h2>
			<p class="text-primary-500 mt-1 font-semibold italic">
				{{ t('essentialsSlide.everplansModal.subtitle') }}
			</p>
			<p class="text-secondary-600 mt-4">
				{{ t('essentialsSlide.everplansModal.description') }}
			</p>
		</div>

		<ul class="mt-6 flex flex-col gap-3">
			<li
				v-for="(benefit, index) in tm(
					'essentialsSlide.everplansModal.benefits'
				)"
				:key="index"
				class="bg-background-50 flex items-start gap-2 rounded-md p-3"
			>
				<CheckCircleIcon class="text-accent-600 size-6 shrink-0" />
				<span class="text-secondary-900 font-medium">{{ benefit }}</span>
			</li>
		</ul>
	</PrecoaModal>
</template>

<script setup lang="ts">
import PrecoaModal from '@/components/common/PrecoaModal.vue'
import CheckCircleIcon from '@heroicons/vue/24/solid/CheckCircleIcon'
import { useI18n } from 'vue-i18n'

const { t, tm } = useI18n()

const props = defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ (e: 'update:modelValue', value: boolean): void }>()
</script>
